import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Button } from '@/components/ui/button';
import { Trash2, FolderInput, X } from 'lucide-react';

interface BulkActionsBarProps {
  selectedCount: number;
  onClear: () => void;
  onDelete?: () => void;
  onMove?: () => void;
}

export function BulkActionsBar({
  selectedCount,
  onClear,
  onDelete,
  onMove
}: BulkActionsBarProps) {
  useLanguage();
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-white border border-[#E5E7EB] shadow-[0_8px_32px_rgba(0,0,0,0.12)] rounded-full px-6 py-3 flex items-center gap-4">
        <span className="text-sm font-medium text-[#1A1A1A]">
          {selectedCount} {selectedCount === 1 ? translateInterfaceText("vídeo selecionado") : translateInterfaceText("vídeos selecionados")}
        </span>
        
        <div className="flex items-center gap-2">
          {onMove && (
            <Button variant="outline" size="sm" onClick={onMove} className="border-[#E5E7EB]">
              <FolderInput className="mr-2 h-4 w-4" />
              {translateInterfaceText("Mover")}</Button>
          )}
          
          {onDelete && (
            <Button 
              size="sm" 
              onClick={onDelete}
              className="bg-red-600 hover:bg-red-700 text-white"
            >
              <Trash2 className="mr-2 h-4 w-4" />
              {translateInterfaceText("Excluir")}</Button>
          )}
          
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onClear} 
            className="hover:bg-transparent hover:text-inherit focus:bg-transparent focus:text-inherit active:bg-transparent active:text-inherit transition-none focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            <X className="h-4 w-4 text-[#6B7280]" />
          </Button>
        </div>
      </div>
    </div>
  );
}
